import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.css']
})
export class TopNavComponent implements OnInit {
  public title:string;
  constructor() { }

  ngOnInit() {
    this.title = 'MineSweeper';
  }

}



// WEBPACK FOOTER //
// ./src/app/top-nav/top-nav.component.ts